import { Snackbar, Alert } from "@mui/material";

const ErrorSnackbar = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity="error"
        variant="filled"
        sx={{
          backgroundColor: "#dc2626",
          fontWeight: 500,
          borderRadius: "8px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorSnackbar;
